import { useCallback, useEffect, useState } from 'react';

import { useNotifications } from '../NotificationContext';
import type { Notification } from '../types/notification.types';

export const useDialogNotification = () => {
  const { notifications, markAsRead } = useNotifications();
  const [dialogNotification, setDialogNotification] =
    useState<Notification | null>(null);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  // Check for dialog notifications
  useEffect(() => {
    // Find the first unread dialog notification
    const unreadDialog = notifications.find(
      (notification) =>
        notification.type.toLowerCase() === 'dialog' && !notification.is_read,
    );

    if (unreadDialog && !isDialogOpen) {
      setDialogNotification(unreadDialog);
      setIsDialogOpen(true);
    }
  }, [notifications, isDialogOpen]);

  // Handle closing the dialog
  const handleCloseDialog = useCallback(() => {
    setIsDialogOpen(false);
    // We don't clear the notification here anymore
    // This ensures the user must click "تم القراءة" to close the dialog
  }, []);

  // Handle marking as read
  const handleMarkAsRead = useCallback(
    async (id: string) => {
      await markAsRead(id);
      setIsDialogOpen(false);
      setDialogNotification(null);
    },
    [markAsRead],
  );

  return {
    dialogNotification,
    isDialogOpen,
    handleCloseDialog,
    handleMarkAsRead,
  };
};
